var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["o-width-limiter o-width-limiter--main", _vm.className] },
    [
      _c(
        "div",
        { staticClass: "o-grid t-margin--1-top" },
        _vm._l(_vm.puffs, function(puff, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "o-grid__column c-puff-block__group",
              attrs: { "data-size": "md:12 lg:4" }
            },
            [
              _c(
                "div",
                {
                  class: [
                    "c-puff-block",
                    puff.className,
                    puff.color === "orange" && "bg-orange",
                    puff.color === "pink" && "bg-pink",
                    puff.color === "blue" && "bg-blue",
                    puff.color === "green" && "bg-green",
                    puff.url && "has-link"
                  ]
                },
                [
                  _c("div", { staticClass: "c-puff-block--imagearea" }, [
                    _c("img", {
                      attrs: { src: puff.src, alt: puff.alt, title: puff.text }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-puff-block--textarea" }, [
                    puff.url !== ""
                      ? _c("a", { attrs: { href: puff.url } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(puff.text) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      : _c(
                          "p",
                          {
                            class: [
                              puff.textAlignment === "left" && "text-left",
                              puff.textAlignment === "center" && "text-center",
                              puff.textAlignment === "right" && "text-right"
                            ]
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(puff.text) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }